import React from 'react';
import { Box, Center } from '@chakra-ui/react';

import CountDown from '@/components/Common/CountDown/V3';
import AddToCalendar from '@/components/Common/AddToCalendar';
import WithAnimation from '@/components/Common/WithAnimation';
import PeacockImage from '@components/Common/Icons/Peacock';

import { BG_COUNTING_DOWN } from '@/constants/assets';
import { BUTTON_GRADIENT, BUTTON_PROPS } from '@/constants/colors';
import { string } from 'prop-types';

function CountingDown({ lang }) {
  return (
    <Box
      bgColor="bgPrimary"
      padding="52px 24px 62px 24px"
      minHeight="300px"
      bgImage={`url(${BG_COUNTING_DOWN})`}
      bgSize="cover"
      bgPosition="top"
    >
      <Box width="100%" borderRadius="16px">
        <Center>
          <Box maxW="388px" position="absolute" width="100%">
            {false && <PeacockImage
              height="80px"
              width="auto"
              id="countdown-peacock"
              position="absolute"
              transform="scaleX(-1)"
              left="38px"
              marginTop="-4px"
              zIndex="4"
            />}
          </Box>
        </Center>
        <CountDown lang={lang} />
        <WithAnimation>
          <Center>
            <AddToCalendar
              text="INGATKAN SAYA"
              size="xs"
              textTransform="uppercase"
              fontFamily="body"
              letterSpacing="2px"
              color="mainColorText"
              bgColor="bgSecondary"
              boxShadow="xl"
              background={BUTTON_GRADIENT}
              {...BUTTON_PROPS}
            />
          </Center>
        </WithAnimation>
      </Box>
    </Box>
  );
}

CountingDown.propTypes = {
  lang: string.isRequired,
};

export default CountingDown;
